module.exports = __webpack_public_path__ + "img/1.bfdb5109.gif";